import PurchaseOrders from 'types/entities/PurchaseOrders';

export const PurchaseOrderActions = {
  GET_PURCHASE_ORDER_LIST: 'GET_PURCHASE_ORDER_LIST',
} as const;

// export const getPurchaseOrderAction = (payload: { data?: PurchaseOrders[] }) => ({
//   type: PurchaseOrderActions.GET_PURCHASE_ORDER_LIST,
//   payload,
// });

export const getPurchaseOrderAction = (payload: PurchaseOrders[]) => ({
  type: PurchaseOrderActions.GET_PURCHASE_ORDER_LIST,
  payload,
});

export const purchaseOrderActions = {
  getPurchaseOrderAction,
};
